// Minimal service-worker registration. CRA builds src/service-worker.js to the
// site root, where we register it. Web-only by nature (SIFISO is a web app).
export function register() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
      navigator.serviceWorker.register(swUrl).catch((err) => console.error('[SIFISO] SW registration failed', err));
    });
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then((r) => r.unregister()).catch(() => {});
  }
}
